// Country → default cost currency. Authored under the API (ships in the Functions
// package) and shared into the SPA via the @shared alias, so the wizard's cost
// form and the server backstop agree on the default. Explicit user choice always
// wins over this; it only fills the blank.

/** cases.country value (lowercased) → ISO-4217 currency code. */
export const CURRENCY_BY_COUNTRY = Object.freeze({
  'united kingdom': 'GBP',
  'ireland':        'EUR',
  'united states':  'USD',
});

export const FALLBACK_CURRENCY = 'GBP';

/** Default currency for a case's country; FALLBACK_CURRENCY when unknown/blank. */
export function defaultCurrencyForCountry(country) {
  return CURRENCY_BY_COUNTRY[String(country || '').trim().toLowerCase()] || FALLBACK_CURRENCY;
}
